'use client';

import * as React from 'react';
/**
 * @ignore - internal hook.
 */
export function useForcedRerendering() {
  const [, setState] = React.useState({});
  return React.useCallback(() => {
    setState({});
  }, []);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/utils/useForcedRerendering.js
// module id = 2260
// module chunks = 31